import { http } from '@/core/api';
import type { ApiResult } from '@/core/either';
import { executeRequest } from '@/core/either';
import type { PendingOperationsResponse } from '../types/comexPendingOperations.type';

export const comexPendingOperationsService = {
  /**
   * Obtiene las operaciones COMEX pendientes de la empresa, una entrada por wallet.
   * @returns Promesa con el resultado tipado usando Either (ApiResult<PendingOperationsResponse[]>).
   */
  getPendingOperations(): Promise<ApiResult<PendingOperationsResponse[]>> {
    return executeRequest(() =>
      http.get<PendingOperationsResponse[]>(
        'wallet-b2b/b2b/commerce/pending-operations'
      )
    );
  },
};
